import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { ARCADE_GAMES } from './games';

/** Hidden arcade cabinet (C): game select screen that mounts the chosen game. */
@observer
class ArcadeCabinet extends Component {
    constructor(props) {
        super(props);
        this.state = { selected: null };
    }

    componentDidMount() {
        window.addEventListener('keydown', this.onKeyDown);
        this.loadBests();
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyDown);
    }

    loadBests = async () => {
        const { arcadeScoreStore } = this.props.stores;
        if (arcadeScoreStore?.loadBests) {
            await arcadeScoreStore.loadBests(ARCADE_GAMES.map(g => g.key));
        }
    }

    onKeyDown = (e) => {
        if (this.state.selected) {
            return;
        }
        const index = parseInt(e.key, 10);
        if (index >= 1 && index <= ARCADE_GAMES.length) {
            e.preventDefault();
            this.select(ARCADE_GAMES[index - 1].key);
        }
    }

    select = (key) => {
        this.setState({ selected: key });
    }

    back = () => {
        this.setState({ selected: null });
        this.loadBests();
    }

    render() {
        const { selected } = this.state;
        const { arcadeScoreStore } = this.props.stores;
        const entry = selected ? ARCADE_GAMES.find(g => g.key === selected) : null;
        if (entry && entry.component) {
            const GameComponent = entry.component;
            return (
                <GameComponent
                    stores={this.props.stores}
                    drawerLevel={this.props.drawerLevel}
                    onBack={this.back}
                />
            );
        }
        const bestByGame = arcadeScoreStore?.bestByGame || {};
        return (
            <div class='d-flex flex-column align-items-center p-3 pb-5 bg-black text-white min-vh-100'>
                <h2 class='arcade-hud mb-1'><Text id='arcade.arcade'>Arcade</Text></h2>
                <div class='small text-body-secondary mb-3'><Text id='arcade.chooseGame'>Choose a game</Text></div>
                <div class='d-flex flex-column gap-3 w-100' style='max-width: 420px;'>
                    {ARCADE_GAMES.map((game, index) => {
                        const best = bestByGame[game.key];
                        const bestText = game.formatBest ? game.formatBest(best)
                            : best && best.score > 0 ? best.score : '—';
                        return (
                            <div key={`arcade-game-${game.key}`} class='card bg-dark border-secondary text-white'>
                                <div class='card-body d-flex align-items-center gap-3'>
                                    <span style='font-size: 2rem; line-height: 1;'>{game.icon}</span>
                                    <div class='flex-grow-1'>
                                        <div class='fw-bold'><Text id={game.textKey}>{game.title}</Text></div>
                                        <div class='small text-body-secondary'>
                                            <Text id={game.bestTextKey || 'arcade.personalBest'}>
                                                {game.bestTitle || 'Personal best'}
                                            </Text>: {bestText}
                                        </div>
                                    </div>
                                    <button type='button' class='btn btn-success' onClick={() => this.select(game.key)}>
                                        <Text id='arcade.play'>Play</Text>
                                        <span class='ms-2 text-body-secondary small d-none d-md-inline'>[{index + 1}]</span>
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default ArcadeCabinet;
